/**
 * Calculates exponential backoff delay with jitter (replicates Apollo's implementation).
 * @see https://www.apollographql.com/docs/react/api/link/apollo-link-retry#avoiding-thundering-herd
 */
export const calculateExponentialBackoff = (
	attempt: number,
	initialDelayMs: number,
	maxDelayMs: number,
): number => {
	let exponentialDelay = Math.min(initialDelayMs * Math.pow(2, attempt), maxDelayMs);

	exponentialDelay = Math.random() * exponentialDelay * 2;
	return exponentialDelay;
};
